import { Box } from '@mui/system';

import { OrganizationReasonType } from 'src/services/organisation/organisation.types';

import OrganizationReasonsSettings from './organization-reasons-settings';

export default function JobSettingsCard() {
  return (
    <Box sx={{ width: '100%' }}>
      <OrganizationReasonsSettings type={OrganizationReasonType.JobClose} />
    </Box>
  );
}
